import React, { createContext, useContext, useMemo } from 'react';
import { IUserPreferenceStore, useUserPreference } from '../hooks/useUserPreference';
import { ThemeColorKey } from '../components/config/variables';
import { applyThemeColor, readStoredThemeColor, storeThemeColor } from '../utils/themeColor';

interface IThemeColorContext {
  themeColor: ThemeColorKey;
  setThemeColor: (color: ThemeColorKey) => void;
}

const THEME_COLOR_PREFERENCE: IUserPreferenceStore<ThemeColorKey> = {
  read: readStoredThemeColor,
  store: storeThemeColor,
  apply: applyThemeColor,
};

const ThemeColorContext = createContext<IThemeColorContext | undefined>(undefined);

export const ThemeColorProvider = ({ children }: { children: React.ReactNode }) => {
  const [themeColor, setThemeColor] = useUserPreference(THEME_COLOR_PREFERENCE);

  const value = useMemo(() => ({ themeColor, setThemeColor }), [themeColor, setThemeColor]);

  return <ThemeColorContext.Provider value={value}>{children}</ThemeColorContext.Provider>;
};

export const useThemeColor = (): IThemeColorContext => {
  const context = useContext(ThemeColorContext);
  if (!context) {
    throw new Error('useThemeColor must be used within a ThemeColorProvider');
  }
  return context;
};
